import { User } from 'lucide-react';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import SoccerPitchIcon from '../../../icon/soccer-pitch-icon';
import TeamsIcon from '../../../icon/teams-icon';
import MenuItem from '../menu-item/menu-item';
import * as S from './styles';

type UDMenuCategoriesProps = {
  className?: string;
};

const UDMenuCategories = React.memo((props: UDMenuCategoriesProps) => {
  return (
    <S.MenuMainNavigation className={props.className}>
      <div className={'flex flex-col'}>
        <MenuItem to={Pages.TEAMS.INDEX} icon={<TeamsIcon />} label={'Команды'} />

        <MenuItem to={Pages.PLAYERS.INDEX} icon={<User size={16} />} label={'Игроки'} />

        <MenuItem to={Pages.LOCATIONS.INDEX} icon={<SoccerPitchIcon />} label={'Локации'} />
      </div>
    </S.MenuMainNavigation>
  );
});

export default UDMenuCategories;
